import BusinessBanner from './BusinessBanner';

export default BusinessBanner;